import { environment } from "@/lib/resources";
import { FriendlyCaptchaSDK, type WidgetHandle } from "@friendlycaptcha/sdk";

const sdk = new FriendlyCaptchaSDK();

export function mountCaptcha(mount: HTMLElement): WidgetHandle {
	return sdk.createWidget({
		element: mount,
		sitekey: environment.friendlyCaptchaSitekey,
	});
}

export function mountCaptchaInForm(form: JQuery<HTMLFormElement> | HTMLFormElement): WidgetHandle {
	let container = $(form).find(".frc-captcha")[0];
	if (!container) {
		throw new Error(`kein '.frc-captcha' Element in form`);
	}

	return mountCaptcha(container);
}
